<template>
  <div class="lists">
    <h1>Lists</h1>
    <div v-for="list in lists" v-bind:key="list.id">
      <list-index-entry :list="list" :user="list.user"></list-index-entry>
    </div>
  </div>
</template>

<script>
import ListsService from '@/services/ListsService'
import ListIndexEntry from '@/components/ListIndexEntry'
export default {
  name: 'lists',
  components: {
    ListIndexEntry
  },
  data () {
    return {
      lists: []
    }
  },
  mounted () {
    this.getLists()
  },
  methods: {
    async getLists () {
      const response = await ListsService.fetchLists()
      this.lists = response.data.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lists.vue